import { Component, ElementRef, HostListener, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormHeader } from "../../../settings/model/form.model";

@Component({
  selector: 'form-headers',
  templateUrl: './form-headers.component.html',
  styleUrls: ['./form-headers.component.scss']
})
export class FormHeadersComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.prepareFormHeaders();
  }

  @Input() formHeaders?: FormHeader[];
  @ViewChildren('headerElem') headerElems!: QueryList<ElementRef>;

  ngOnInit(): void {
    this.prepareFormHeaders();
  }

  private prepareFormHeaders(): void {
    let offset = 56;

    setTimeout(() => {
      const elems = this.headerElems.toArray();
      const headers = this.formHeaders;

      if (headers) {
        this.formHeaders = headers.map((header, index) => {
          if (header.sticky) {
            const height = elems[index].nativeElement.offsetHeight;
            const newTop = offset;
            offset += height;
            return { ...header, top: newTop };
          } else {
            return { ...header, top: undefined };
          }
        });
      }
    })
  }
}
